import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Actions.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Loader from 'components/UI/Loader/Loader'
import AddEditActionsModal from './AddEditActionsModal/AddEditActionsModal'
import RowAction from './RowAction/RowAction'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'

const Actions = () => {
  const [actions, setActions] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchSkills = () => {
    superAxiosRequest({
      method: 'get',
      link: 'db/coin_activities',
    }).then(({ data }) => {
      setActions(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchSkills()
  }, [])

  const onBeforeSubmitClient = (data) => {
    const { name, ...rest } = data
    return {
      ...rest,
      ...(name && { name: data.name }),
    }
  }

  const addAction = () => {
    const ms = {
      modalBodyComponent: () => <AddEditActionsModal />,
      button: 'Save',
      link: 'db/coin_activities',
      title: 'Добавить действие',
      isResponsive: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: () => {
        fetchSkills()
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, {})
  }

  const editAction = (data) => {
    const ms = {
      modalBodyComponent: () => <AddEditActionsModal />,
      button: 'Save',
      link: `db/coin_activities/${data?.id}`,
      title: 'Редактировать действие',
      isResponsive: true,
      is_put: true,
      onBeforeSubmit: onBeforeSubmitClient,
      onSubmitSuccess: (data) => {
        setActions((prev) =>
          prev.map((action) =>
            action.id === data.id ? { ...action, ...data } : action,
          ),
        )
      },
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, data)
  }

  const deleteAction = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the action?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `db/coin_activities/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setActions((prev) => prev.filter((action) => action?.id !== data?.id))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editAction(items)],
      ['delete', () => deleteAction(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Действия для IPM'}>
          {checkPermList(permissions.add_coinactivity) && (
            <HeaderAddButton title={'Добавить действие'} onClick={addAction} />
          )}
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Записей: {actions?.length || 0}
          </div>
          <div>
            {actions?.map((activity, index) => (
              <RowAction
                key={action.id}
                activity={activity}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Actions
